module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAABGklEQVQoU3WRL0hDYRTFf2d7KKviXFkQJsb9eV9bXFQwiEkQTRaTVTDbjBbBZLQIBoMggkMM33vDbBCjmGxP4V3ZcxvPPf3aOb9z4bvniqlnzm0CG/J+PY+UF9ZudymXb4EZzE4VRbtjPglaq7VMEDwAc7nhA3l/NNRZ0JrNBYLgEWlx+iuYbSmKzmX1eoVarQ90CqEf4xOpJwvDS6S1f0Jj+0Pm3DxJUs6c2dkzYCU3tEOSXFOp6PfWzl0Bq7lgVd6/T5YZAwvDPlI302ZPiqJWoZ6MOfcGVEdwT96fFHt0rgE8j8ArsCTvv4rBMDxG2scsxaynOL4rnNA6nRalkgcS0nRbcXwxXdewngZmN8A9aXqoweDlr06/AfPRWIhFcCd5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/energy/on.png
// module id = PEjo
// module chunks = 3